// Explicit immutable document history. Current-version links come from the
// verified App manifest; unknown version-looking routes stay unowned.
export const ARCHIVED_DPA_VERSIONS = Object.freeze(['1.0', '1.1', '1.2']);
